import { 
    SET_CARI_FORM_PAGE_DATA, 
    SET_ACTIVE_POSITION_DATA,
    SET_ACTIVE_APPLICATION_DATA,
    SET_ACTIVE_VERIFIED_LOGIN_USER_DATA,
    SET_CURRENT_USER_DATA,
    SET_URL_PARAM_DATA,
    RESET_ALL_DATA,
    RESET_ACTIVE_POSITION_DATA,
    RESET_ACTIVE_APPLICATION_DATA,
    RESET_URL_PARAM_DATA,
    OPEN_CARI_MODAL,
    CLOSE_CARI_MODALS,
} from "../constants/actionTypes";


/*
    payload = {
        page_num: ,
        pagedata: [],
    }
*/
export const setCariFormPageData = page_data => ({ type: SET_CARI_FORM_PAGE_DATA, payload: page_data, page_num: page_data.page_num});

/*
    payload = {
        position_title
        position_id
    }
*/
export const setCariFormActivePositionData = position_data => ({ type: SET_ACTIVE_POSITION_DATA, payload: position_data});

/*
    payload = {
        application_id,
        application_status
    }
*/
export const setCariFormActiveApplicationData = application_data => ({ type: SET_ACTIVE_APPLICATION_DATA, payload: application_data });

/*

    payload = {
        email
        token //TODO remove later,
    }
*/
//note this is seperate to prevent user logout
export const setCariActiveVerifiedLoginUserData = user_data => ({ type: SET_ACTIVE_VERIFIED_LOGIN_USER_DATA, payload: user_data });

/*
    payload = {
        first_name,
        last_name
    }
*/
export const setCariActiveUserData = user_data => ({ type: SET_CURRENT_USER_DATA, payload: user_data });

/*
    payload = {
        url_params_set
    }
*/
export const setCariUrlParamsData = url_params_data => ({ type: SET_URL_PARAM_DATA, payload: url_params_data });

export const resetCariActiveData = () => ({ type: RESET_ALL_DATA });

export const resetCariActivePositionData = () => ({ type: RESET_ACTIVE_POSITION_DATA });

export const resetCariActiveApplicationData = () => ({ type: RESET_ACTIVE_APPLICATION_DATA });

export const resetCariUrlParamsData = () => ({ type: RESET_URL_PARAM_DATA });

//modals
/*
    payload = {
        modalId: "name of modal",
        title: "", //optional
        content: "", //optional
        callBackFuncOnOk: "", //optional
        callBackFuncOnCancel: "", //optional
    }
*/
//opens one cari modal
export const openCariModal = (modal_data) => ({ type: OPEN_CARI_MODAL, payload: modal_data});

//closes all cari modals 
export const closeCariModals = () => ({ type: CLOSE_CARI_MODALS});
